const routeNames = {
    'contato':'contact',
    'contact':'contato',
    'politica-de-privacidade':'privacy-policy',
    'privacy-policy':'politica-de-privacidade'
}

export default routeNames;